// PageViewTracker.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePostHog } from 'posthog-js/react';
import ReactGA from 'react-ga4';

function PageViewTracker() {
  const location = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
    // Track page view in PostHog
    if (posthog) {
      console.log('Tracking pageview:', location.pathname);
      posthog.capture('$pageview');
    }

    // Track page view in Google Analytics
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname,
      title: document.title,
    });
  }, [location.pathname, posthog]);

  return null;
}

export default PageViewTracker;
